import { useState } from "react";

const DAAModal = ({ vehicle, accident, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    daa_number: '',
    daa_date: new Date().toISOString().split('T')[0],
    other_party_name: '',
    other_party_vehicle: '',
    other_party_plate: '',
    other_party_insurance: '',
    other_party_policy: '',
    our_fault_percentage: 0,
    description: '',
    file_url: ''
  });
  const [fileName, setFileName] = useState('');

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData({...formData, file_url: reader.result, file_name: file.name, file_type: file.type});
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-slate-800 rounded-xl border border-slate-700 w-full max-w-lg max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
        <div className="p-6 border-b border-slate-700">
          <h3 className="text-xl font-bold text-white">Carregar DAA</h3>
          <p className="text-sm text-slate-400 mt-1">Declaração Amigável de Acidente</p>
          <p className="text-sm text-blue-400 mt-1">{vehicle.license_plate} - Sinistro de {accident?.date}</p>
        </div>
        <div className="p-6 space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">Nº da DAA</label>
              <input
                type="text"
                value={formData.daa_number}
                onChange={e => setFormData({...formData, daa_number: e.target.value})}
                className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-300 mb-1">Data da DAA</label>
              <input
                type="date"
                value={formData.daa_date}
                onChange={e => setFormData({...formData, daa_date: e.target.value})}
                className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
              />
            </div>
          </div>
          
          <div className="p-3 bg-slate-700/50 rounded-lg">
            <h4 className="text-sm font-semibold text-white mb-3">Dados do Outro Veículo</h4>
            <div className="space-y-3">
              <div>
                <label className="block text-xs text-slate-400 mb-1">Nome do Condutor</label>
                <input
                  type="text"
                  value={formData.other_party_name}
                  onChange={e => setFormData({...formData, other_party_name: e.target.value})}
                  className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white text-sm"
                />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs text-slate-400 mb-1">Veículo</label>
                  <input
                    type="text"
                    value={formData.other_party_vehicle}
                    onChange={e => setFormData({...formData, other_party_vehicle: e.target.value})}
                    className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white text-sm"
                    placeholder="Marca/Modelo"
                  />
                </div>
                <div>
                  <label className="block text-xs text-slate-400 mb-1">Matrícula</label>
                  <input
                    type="text"
                    value={formData.other_party_plate}
                    onChange={e => setFormData({...formData, other_party_plate: e.target.value})}
                    className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white text-sm"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs text-slate-400 mb-1">Seguradora</label>
                  <input
                    type="text"
                    value={formData.other_party_insurance}
                    onChange={e => setFormData({...formData, other_party_insurance: e.target.value})}
                    className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white text-sm"
                  />
                </div>
                <div>
                  <label className="block text-xs text-slate-400 mb-1">Nº Apólice</label>
                  <input
                    type="text"
                    value={formData.other_party_policy}
                    onChange={e => setFormData({...formData, other_party_policy: e.target.value})}
                    className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white text-sm"
                  />
                </div>
              </div>
            </div>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Percentagem de Culpa Nossa</label>
            <div className="flex items-center gap-3">
              <input
                type="range"
                min="0"
                max="100"
                value={formData.our_fault_percentage}
                onChange={e => setFormData({...formData, our_fault_percentage: parseInt(e.target.value)})}
                className="flex-1"
              />
              <span className="text-white font-bold w-12">{formData.our_fault_percentage}%</span>
            </div>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Ficheiro DAA (PDF/Imagem)</label>
            <div className="border-2 border-dashed border-slate-600 rounded-lg p-4 text-center">
              <input
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={handleFileChange}
                className="hidden"
                id="daa-file"
              />
              <label htmlFor="daa-file" className="cursor-pointer">
                {fileName ? (
                  <p className="text-emerald-400">{fileName}</p>
                ) : (
                  <p className="text-slate-400">Clique para selecionar ficheiro</p>
                )}
              </label>
            </div>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-slate-300 mb-1">Observações</label>
            <textarea
              value={formData.description}
              onChange={e => setFormData({...formData, description: e.target.value})}
              className="w-full px-3 py-2 rounded-lg bg-slate-700 border border-slate-600 text-white"
              rows={2}
            />
          </div>
        </div>
        
        <div className="p-6 border-t border-slate-700 flex justify-end gap-3">
          <button onClick={onClose} className="px-4 py-2 rounded-lg bg-slate-700 text-white hover:bg-slate-600">
            Cancelar
          </button>
          <button
            onClick={() => onSave(vehicle.vehicle_id, accident.accident_id, formData)}
            className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-500"
          >
            Carregar DAA
          </button>
        </div>
      </div>
    </div>
  );
};

export default DAAModal;
